import { render, staticRenderFns } from "./ContactStandmanForm.vue?vue&type=template&id=345fd791&"
import script from "./ContactStandmanForm.vue?vue&type=script&lang=ts&"
export * from "./ContactStandmanForm.vue?vue&type=script&lang=ts&"
import style0 from "./ContactStandmanForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VSelect,VTextField})
